/*----------------------------------------------------------------------------
|
|   Small wrappers for doing REST calls (GET,POST,PUT,DELETE) for JSON
|   objects with ability to visually show activity (spinning icon...)
|
|   override following function if other behaviour is needed.
|
|     * reflectActivity
|     * errorHandler
|
|   Jochen Lower
|   July 2014
|
\---------------------------------------------------------------------------*/

// Usage:
//   var data = { 'first name': 'George', 'last name': 'Jetson', 'age': 110 };
//   var querystring = constructURL(data);
// 
function constructURL(data)
{
  var ret = [];
  for (var d in data)
    ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
  return ret.join("&");
}


function getQueryParams(qs)
{
   qs = qs.split("+").join(" ");

   var params = {}, tokens,
       re = /[?&]?([^=]+)=([^&]*)/g;
           
   while (tokens = re.exec(qs)) {
       params[decodeURIComponent(tokens[1])]
                = decodeURIComponent(tokens[2]);
   }
   return params;
}


var runningCalls = 0;
function reflectActivity (incrDecr)
{
  runningCalls = runningCalls + incrDecr;
  if (runningCalls > 0) {
    $("#spinningIcon").show();
  } else {
    $("#spinningIcon").hide();
  }
}

function errorHandler(statusText, response, respText) 
{
  
}

function isValidJSON(jsonString) {
  try {
    JSON.parse(jsonString);
    return true;
  } catch (error) {
    return false;
  }
}

function RewriteRESTURL(url)
{
  var urlWithAAID = /\/os\/(da|qad-nl|qad-il|qad-us|qad-jp|etr|[ie]?gpp|[ie]?gpp_lar|iscs|sipa|jpoem|[ie]?ppro|[ie]?pproemea|[ie]?psweb|[ie]?pweb|tdc)\//

  if ( url.match(/^ossui\/|^invoiceStatusExt/)
    && document.location.pathname.match(urlWithAAID)
  ) {
    console.log('> REST POST: re-writing ',url,' to ','../'+url);
    return ('../' + url);
  }
  if ( url.match(/^shipmentPackListExt/) ) {
    console.log('> REST POST: re-writing ',url,' to ','../'+url);
    if ( sfdcSession ) {
      return ('/os/' + url);
    } else if ( document.location.pathname.match(urlWithAAID) )  {
      return ('../' + url);
    }
  }
  if ( url.match(/^ossui\//)
    && document.location.pathname.match(urlWithAAID)
  ) {
    console.log('> REST POST: re-writing ',url,' to ','../'+url);
    return ('../' + url);
  }
  return url
  
}

// Updates the responseText in case we get an HTML Back
function updateRESTErrorResponseText(xhr) {
  if  ( typeof xhr !== "undefined" ) {
    xhr.responseText = xhr.responseText || "";
    if ( typeof xhr.status !== "undefined" ) {
      if ( (xhr.status > 400 && xhr.status < 500) || xhr.status > 500) {
        xhr.responseText =   "Error occured while trying to contact server. "
                           + "Kindly contact support in case this reoccurs.";
      } else if ( xhr.status == 400 || xhr.status == 500 ) {
        // If Response Status is 400 or 500 then this could be JSON and
        // can be passed over rather than Generic mesasge
        try {
          var responseError = JSON.parse(xhr.responseText);
        } catch(err) {
          xhr.responseText =   "Error occured while trying to contact server. "
                             + "Kindly contact support in case this reoccurs.";
        }
      }
    }
  }
}

function GET(url, params, cb, errcb) {
  return GETwithTimeout(url, params, 41000, cb, errcb);
}

function GETwithTimeout(url, params, timeout, cb, errcb) 
{
  url = RewriteRESTURL(url);
  if (params && typeof params.sfdcSession !== 'undefined') {
    sfdcSession = params.sfdcSession;
  } else sfdcSession = '';
  console.log('> REST GET', sfdcSession, url, params);
  reflectActivity(+1);
  $.ajax( { 
    dataType: "json", 
    url: url,  
    data: params, 
    beforeSend: function(xhr) {
      if (sfdcSession) {
        xhr.setRequestHeader("sfdcsession", sfdcSession);
      }
    },
    timeout: timeout,
    statusCode: {
      302: function(xhr) {
        console.log('> REST GET got 302', url, params);
        reflectActivity(-1);
        updateRESTErrorResponseText(xhr);
        if (errcb != undefined) {
          return errcb(xhr.statusText, xhr.responseText);
        } else {
          try {
            var responseError = JSON.parse(xhr.responseText); 
            console.log(responseError); 
            return errorHandler(xhr.statusText, responseError, xhr.responseText);
          } catch(err) {
            return errorHandler(xhr.statusText, null, xhr.responseText);
          }
        }  
      }
    },
    success: function( data ) {
      reflectActivity(-1);
      console.log('> REST GET OK!', url, JSON.stringify(params));
      cb(data);
    }, 
    error: function (xhr, statusText, errorThrown) {
      reflectActivity(-1);
      console.log('> REST GET :-( error', url, JSON.stringify(params));
      console.log('> REST GET statusText:', statusText);
      console.log('> REST GET errorThrown:', errorThrown);
      console.log('> REST GET xhr:', JSON.stringify(xhr));
      console.log('> REST GET responseText:', JSON.stringify(xhr.responseText));
      updateRESTErrorResponseText(xhr);

      var responseError = xhr.responseText;
      if (xhr.hasOwnProperty('responseText') && xhr.responseText != "") {
        if (isValidJSON(xhr.responseText)) {
          responseError = JSON.parse(xhr.responseText);
        } else {
          responseError = xhr.responseText;
        }
      }

      if (errcb != undefined) {
        return errcb(statusText, responseError, xhr.responseText, params);
      } else {
        return errorHandler(statusText, responseError, xhr.responseText, params);
      }
    }                   
  });  
}

function POST(url, params, cb, errcb, progresscb) 
{
  url = RewriteRESTURL(url);
  console.log('> REST POST', url, params);
  reflectActivity(+1);
  $.ajax( { 
    xhr: function()
    {
      var xhr = new window.XMLHttpRequest();
      //Upload progress
      xhr.upload.addEventListener("progress", function(evt){
        if (evt.lengthComputable) {
          var percentComplete = evt.loaded / evt.total;
          //console.log("upload: ",percentComplete);
          if (progresscb) {
            progresscb(percentComplete);
          }
        }
      }, false);
      //Download progress
      xhr.addEventListener("progress", function(evt){
        if (evt.lengthComputable) {
          var percentComplete = evt.loaded / evt.total;
          //console.log("download: ",percentComplete);
          if (progresscb) {
            progresscb(percentComplete);
          }
        }
      }, false);
      return xhr;
    },
    dataType: "json", 
    type: 'POST',
    contentType: 'application/json',
    url: url,  
    data: JSON.stringify(params),
    timeout: 242000,
    success: function( data ) {
      reflectActivity(-1);
      console.log('> REST POST OK!', url, JSON.stringify(params), JSON.stringify(data));
      cb(data);
    }, 
    error: function (xhr, statusText, errorThrown) {
      reflectActivity(-1);
      
      console.log('> REST POST :-( error', url, JSON.stringify(params));
      console.log('> REST POST statusText:', statusText);
      console.log('> REST POST errorThrown:', errorThrown);
      console.log('> REST POST xhr:',JSON.stringify(xhr));
      console.log('> REST POST responseText:',JSON.stringify(xhr.responseText));
      var originalResponseText = xhr.responseText;
      updateRESTErrorResponseText(xhr);

      var responseError = xhr.responseText;
      if (xhr.hasOwnProperty('responseText') && xhr.responseText != "") {
        if (isValidJSON(xhr.responseText)) {
          responseError = JSON.parse(xhr.responseText);
        } else {
          responseError = xhr.responseText;
        }

      }

      if (errcb != undefined) {
        return errcb(statusText, responseError, xhr.responseText, params);
      } else {
        return errorHandler(statusText, responseError, xhr.responseText, params);
      }
 
    }                   
  });  
}

function POST_nojson(url, params, cb, errcb) 
{
  url = RewriteRESTURL(url);
  console.log('> REST POST', url, params);
  reflectActivity(+1);
  $.ajax( { 
    type: 'POST',
    contentType: 'application/json',
    url: url,  
    data: JSON.stringify(params),
    timeout: 121000,
    success: function( data ) {
      reflectActivity(-1);
      console.log('> REST POST OK!', url, JSON.stringify(params), JSON.stringify(data));
      cb(data);
    }, 
    error: function (xhr, statusText, errorThrown) {
      reflectActivity(-1);
      
      console.log('> REST POST :-( error', url, params);
      console.log('> REST POST statusText:', statusText);
      console.log('> REST POST errorThrown:', errorThrown);
      console.log('> REST POST xhr:',JSON.stringify(xhr));
      console.log('> REST POST responseText:',JSON.stringify(xhr.responseText));
      updateRESTErrorResponseText(xhr);
      if (errcb != undefined) {
        return errcb(statusText, xhr.responseText);
      } else {
        if (statusText == "timeout") {
          return errorHandler(statusText, {}, "");
        }
        try {
          var responseError = JSON.parse(xhr.responseText); 
          console.log(responseError); 
          return errorHandler(statusText, responseError, xhr.responseText);
        } catch(err) {
          return errorHandler(statusText, null, xhr.responseText);
        }
      }  
    }                   
  });  
}


function DELETE(url, params, cb) 
{
  console.log('> REST DELETE', url, params);
  reflectActivity(+1);
  $.ajax( { 
    dataType: "json", 
    headers: {"X-HTTP-Method-Override": "DELETE"}, // X-HTTP-Method-Override set to DELETE
    type: 'POST',
    contentType: 'application/json',
    url: url,  
    data: JSON.stringify(params),
    timeout: 21000,
    success: function( data ) {
      reflectActivity(-1);
      console.log('> REST DELETE OK!', url, params);
      cb(data);
    }, 
    error: function (xhr, statusText, errorThrown) {
      reflectActivity(-1);
      console.log('> REST DELETE :-( error', url, params);
      console.log('> REST DELETE statusText:', statusText);
      console.log('> REST DELETE errorThrown:', errorThrown);
      console.log('> REST DELETE xhr:',JSON.stringify(xhr));
      console.log('> REST DELETE responseText:',JSON.stringify(xhr.responseText));
      updateRESTErrorResponseText(xhr);
      if (statusText == "timeout") {
        return errorHandler(statusText, {}, "");
      }
      try {
        var responseError = JSON.parse(xhr.responseText); 
        console.log(responseError); 
        return errorHandler(statusText, responseError, xhr.responseText);
      } catch(err) {
        return errorHandler(statusText, null, xhr.responseText);
      }
    }                   
  });  
}


function PUT(url, params, cb) 
{
  console.log('> REST PUT', url, params);
  reflectActivity(+1);
  $.ajax( { 
    dataType: "json", 
    headers: {"X-HTTP-Method-Override": "PUT"}, // X-HTTP-Method-Override set to PUT
    type: 'POST',
    contentType: 'application/json',
    url: url,  
    data: JSON.stringify(params),
    timeout: 21000,
    success: function( data ) {
      reflectActivity(-1);
      console.log('> REST PUT OK!', url, params);
      cb(data);
    }, 
    error: function (xhr, statusText, errorThrown) {
      reflectActivity(-1);
      console.log('> REST PUT :-( error', url, params);
      console.log('> REST PUT statusText:', statusText);
      console.log('> REST PUT errorThrown:', errorThrown);
      console.log('> REST PUT xhr:',JSON.stringify(xhr));
      console.log('> REST PUT responseText:',JSON.stringify(xhr.responseText));
      updateRESTErrorResponseText(xhr);
      if (statusText == "timeout") {
        return errorHandler(statusText, {}, "");
      }
      try {
        var responseError = JSON.parse(xhr.responseText); 
        console.log(responseError); 
        return errorHandler(statusText, responseError, xhr.responseText);
      } catch(err) {
        return errorHandler(statusText, null, xhr.responseText);
      }
    }                   
  });  
}

if (typeof(exports) != "undefined") {
  exports.GET = GET;
  exports.GETwithTimeout = GETwithTimeout;
  exports.POST = POST;
  exports.PUT = PUT;
  exports.DELETE = DELETE;
  exports.getQueryParams = getQueryParams;
  exports.RewriteRESTURL = RewriteRESTURL;
  exports.constructURL   = constructURL;
}